var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNdisclaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8696 16.6237C10.7304 16.8636 10.5306 17.0628 10.2903 17.2012C10.0499 17.3397 9.77738 17.4126 9.5 17.4126C9.22262 17.4126 8.9501 17.3397 8.70974 17.2012C8.46937 17.0628 8.2696 16.8636 8.13042 16.6237M14.25 6.33203C14.25 5.07225 13.7496 3.86407 12.8588 2.97327C11.968 2.08248 10.7598 1.58203 9.5 1.58203C8.24022 1.58203 7.03204 2.08248 6.14124 2.97327C5.25045 3.86407 4.75 5.07225 4.75 6.33203C4.75 11.8737 2.375 13.457 2.375 13.457H16.625C16.625 13.457 14.25 11.8737 14.25 6.33203Z",
    stroke: "#0BA5EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdisclaims);
export default __webpack_public_path__ + "static/media/ndisclaims.ea28331f277ba74da842b4a8fa32f1be.svg";
export { ForwardRef as ReactComponent };